import { NotAuthorized, NotFound, PasswordChanged } from "@modernary/mui/components/common";
import type { RouterOptions } from "vue-router";
import NotImplemented from "./components/NotImplemented.vue";
import accessRequestRoutes, { accessRequestRouteNames } from "./views/accessRequest/accessRequestRoutes";
import applicationRoutes, { applicationRouteNames } from "./views/application/applicationRoutes";
import asbestosEnforcementActionRoutes, {
  asbestosEnforcementActionRouteNames,
} from "./views/asbestosEnforcementActions/asbestosEnforcementActionRoutes";
import asbestosFacilityRoutes, { asbestosFacilityRouteNames } from "./views/asbestosFacility/asbestosFacilityRoutes";
import asbestosInspectionRoutes, {
  asbestosInspectionRouteNames,
} from "./views/asbestosInspections/asbestosInspectionRoutes";
import asbestosNotificationRoutes, {
  asbestosNotificationRouteNames,
} from "./views/asbestosNotifications/asbestosNotificationRoutes";
import asbestosProjectRoutes, { asbestosProjectRouteNames } from "./views/asbestosProjects/asbestosProjectRoutes";
import { complaintRouteNames, default as complaintRoutes } from "./views/complaint/complaintRoutes";
import complaintEnforcementActionRoutes, {
  complaintEnforcementActionRouteNames,
} from "./views/complaintEnforcementActions/complaintEnforcementActionRoutes";
import complaintInvestigationRoutes, {
  complaintInvestigationRouteNames,
} from "./views/complaintInvestigations/complaintInvestigationRoutes";
import constructionProjectRoutes, {
  constructionProjectRouteNames,
} from "./views/constructionProject/constructionProjectRoutes";
import dustCardRoutes, { dustCardRouteNames } from "./views/dustCard/dustCardRoutes";
import dustClassRoutes, { dustClassRouteNames } from "./views/dustClass/dustClassRoutes";
import dustEnforcementActionRoutes, {
  dustEnforcementActionRouteNames,
} from "./views/dustEnforcementActions/dustEnforcementActionRoutes";
import dustInspectionRoutes, { dustInspectionRouteNames } from "./views/dustInspections/dustInspectionRoutes";
import dustMonitorCardRoutes, { dustMonitorCardRouteNames } from "./views/dustMonitorCard/dustMonitorCardRoutes";
import dustMonitorRoutes, { dustMonitorRouteNames } from "./views/dustMonitorClass/dustMonitorClassRoutes";
import asbestosRoutes, { asbestosRouteNames } from "./views/electronicForm/asbestosForm/asbestosRoutes";
import complianceRoutes, { complianceRouteNames } from "./views/electronicForm/complianceForm/complianceRoutes";
import dustClassRegistrationRoutes, {
  dustClassRegistrationRouteNames,
} from "./views/electronicForm/dustClassRegistration/dustClassRoutes";
import dustFormRoutes, {
  dustFormPermittingRouteNames,
} from "./views/electronicForm/dustControlPermitting/dustFormRoutes";
import dustMonitorClassRoutes, {
  dustMonitorClassRouteNames,
} from "./views/electronicForm/dustMonitorClassRegistration/dustMonitorClassRoutes";
import electronicFormRoutes, { electronicFormRouteNames } from "./views/electronicForm/electronicFormRoutes";
import enforcementRoutes, { enforcementRouteNames } from "./views/electronicForm/enforcementForm/enforcementRoutes";
import openBurningRoutes, { openBurningRouteNames } from "./views/electronicForm/openBurningForm/openBurningRoutes";
import sourceTestingRoutes, {
  sourceTestingRouteNames,
} from "./views/electronicForm/sourceTestingForm/sourceTestingRoutes";
import stationarySourcePermittingRoutes, {
  stationarySourcePermittingRouteNames,
} from "./views/electronicForm/stationarySourcePermitting/stationarySourceRoutes";
import {
  asbestosEnforcementActionRouteName,
  complaintEnforcementActionRouteName,
  dustEnforcementActionRouteName,
  stationarySourceEnforcementActionRouteName,
  vacantLandEnforcementActionRouteName,
} from "./views/enforcementAction/enforcementAction";
import Home from "./views/Home.vue";
import invoiceRoutes, { invoiceRouteNames } from "./views/invoice/invoiceRoutes";
import organizationsRoutes, { organizationRouteNames } from "./views/organization/organizationRoutes";
import dustPermitRoutes, { dustPermitRouteNames } from "./views/dustPermit/dustPermitRoutes";
import personRoutes, { personRouteNames } from "./views/person/personRoutes";
import stationarySourceRoutes, { stationarySourceRouteNames } from "./views/stationarySource/stationarySourceRoutes";
import stationarySourceEnforcementActionRoutes, {
  stationarySourceEnforcementActionRouteNames,
} from "./views/stationarySourceEnforcementActions/stationarySourceEnforcementActionRoutes";
import userRoutes, { userRouteNames } from "./views/user/userRoutes";
import vacantLandEnforcementActionRoutes, {
  vacantLandEnforcementActionRouteNames,
} from "./views/vacantLandEnforcementActions/vacantLandEnforcementActionRoutes";
import vacantLandInspectionRoutes, {
  vacantLandInspectionRouteNames,
} from "./views/vacantLandInspections/vacantLandInspectionRoutes";
import vacantLandParcelRoutes, { vacantLandParcelRouteNames } from "./views/vacantLandParcel/vacantLandParcelRoutes";

// Troubleshoot your routes using this - https://paths.esm.dev

export const routeNames = {
  home: "Home",
  passwordChanged: "PasswordChanged",
  notAuthorized: "NotAuthorized",
  notImplemented: "NotImplemented",
  notFound: "NotFound",
  accessRequest: {
    ...accessRequestRouteNames,
  },
  asbestosFacility: {
    ...asbestosFacilityRouteNames,
  },
  complaint: {
    ...complaintRouteNames,
  },
  complaintInvestigation: {
    ...complaintInvestigationRouteNames,
  },
  [complaintEnforcementActionRouteName]: {
    ...complaintEnforcementActionRouteNames,
  },
  constructionProject: {
    ...constructionProjectRouteNames,
  },
  electronicForm: {
    ...asbestosRouteNames,
    ...complianceRouteNames,
    ...enforcementRouteNames,
    ...dustFormPermittingRouteNames,
    ...openBurningRouteNames,
    ...sourceTestingRouteNames,
    ...stationarySourcePermittingRouteNames,
    ...electronicFormRouteNames,
    ...dustClassRegistrationRouteNames,
    ...dustMonitorClassRouteNames,
  },
  invitation: {
    respond: "Invitations.Respond",
  },
  invoice: {
    ...invoiceRouteNames,
  },
  stationarySource: {
    ...stationarySourceRouteNames,
  },
  [stationarySourceEnforcementActionRouteName]: {
    ...stationarySourceEnforcementActionRouteNames,
  },
  vacantLandParcel: {
    ...vacantLandParcelRouteNames,
  },
  [vacantLandEnforcementActionRouteName]: {
    ...vacantLandEnforcementActionRouteNames,
  },
  organization: {
    ...organizationRouteNames,
  },
  person: {
    ...personRouteNames,
  },
  dustInspection: {
    ...dustInspectionRouteNames,
  },
  dustClass: {
    ...dustClassRouteNames,
  },
  dustCard: {
    ...dustCardRouteNames,
  },
  dustMonitorClass: {
    ...dustMonitorRouteNames,
  },
  dustMonitorCard: {
    ...dustMonitorCardRouteNames,
  },
  dustPermit: {
    ...dustPermitRouteNames,
  },
  application: {
    ...applicationRouteNames,
  },
  [dustEnforcementActionRouteName]: {
    ...dustEnforcementActionRouteNames,
  },
  vacantLandInspection: {
    ...vacantLandInspectionRouteNames,
  },
  asbestosProject: {
    ...asbestosProjectRouteNames,
  },
  asbestosNotification: {
    ...asbestosNotificationRouteNames,
  },
  asbestosInspection: {
    ...asbestosInspectionRouteNames,
  },
  [asbestosEnforcementActionRouteName]: {
    ...asbestosEnforcementActionRouteNames,
  },
  user: {
    ...userRouteNames,
  },
};

export const routes: RouterOptions["routes"] = [
  { path: "/", component: Home, name: routeNames.home, meta: { title: "Home" } },
  {
    path: "/password-changed",
    component: PasswordChanged,
    name: routeNames.passwordChanged,
    meta: { title: "Password Changed" },
  },
  {
    path: "/unauthorized",
    component: NotAuthorized,
    name: routeNames.notAuthorized,
    meta: { title: "Not Authorized" },
  },
  {
    path: "/not-implemented",
    component: NotImplemented,
    name: routeNames.notImplemented,
    meta: { title: "Not Implemented" },
  },
  ...accessRequestRoutes,
  ...asbestosEnforcementActionRoutes,
  ...asbestosFacilityRoutes,
  ...asbestosInspectionRoutes,
  ...asbestosProjectRoutes,
  ...asbestosNotificationRoutes,
  ...asbestosRoutes,
  ...complianceRoutes,
  ...complaintRoutes,
  ...complaintEnforcementActionRoutes,
  ...complaintInvestigationRoutes,
  ...constructionProjectRoutes,
  ...dustClassRegistrationRoutes,
  ...dustMonitorClassRoutes,
  ...dustEnforcementActionRoutes,
  ...dustFormRoutes,
  ...dustInspectionRoutes,
  ...electronicFormRoutes,
  {
    path: "/invitations/:token",
    name: routeNames.invitation.respond,
    meta: { title: "Invitation", lookupGroups: ["InvitationStatus"] },
    component: () => import("@/views/invitations/InvitationRespond.vue"),
  },
  ...enforcementRoutes,
  ...invoiceRoutes,
  ...organizationsRoutes,
  ...personRoutes,
  ...openBurningRoutes,
  ...sourceTestingRoutes,
  ...stationarySourceEnforcementActionRoutes,
  ...stationarySourceRoutes,
  ...stationarySourcePermittingRoutes,
  ...userRoutes,
  ...vacantLandEnforcementActionRoutes,
  ...vacantLandInspectionRoutes,
  ...vacantLandParcelRoutes,
  ...dustClassRoutes,
  ...dustCardRoutes,
  ...dustMonitorRoutes,
  ...dustMonitorCardRoutes,
  ...applicationRoutes,
  ...dustPermitRoutes,
  {
    path: "/not-found",
    component: NotFound,
    name: routeNames.notFound,
    meta: { title: "Not Found" },
  },
  { path: "/:path(.*)", component: NotFound },
];
